import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem } from 'primeng/api';
import { ArtistProductsSummaryRequest, ConsignedProductsRequest } from 'src/app/Services/artistproducts.service';
import { ArtistsService } from 'src/app/Services/artists.service';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { ProductRequest, ProductRequestHistory, ProductRequestQueueService } from 'src/app/Services/product-request-queue.service';

@Component({
    selector: 'app-gallery-requested-product',
    templateUrl: './gallery-requested-product.component.html',
    styleUrls: ['./gallery-requested-product.component.css'],
    providers: [ArtistsService],
    standalone: false
})
export class GalleryRequestedProductComponent implements OnInit {
  public authConfig!: AuthConfig;
  public requestedProducts: ProductRequest[] = [];
  public history: ProductRequestHistory[] = [];
  public galleryId!: string;
  public artistId: string | null = null;

  public searchText: string = ''; // Property to store the search query
  public filters: ArtistProductsSummaryRequest = {};
  public connectedArtists: SelectItem[] = [];
  public selectedArtistId: SelectItem<any> | undefined;
  public totalRequestedProduct: number = 0;
  public isLoading: boolean = true;
  public productRequestHistoryVisible: boolean = false;
  public statusFilterOptions: SelectItem[] = [
    { label: 'Pending', value: 'Pending' },
    { label: 'Accepted', value: 'Accepted' },
    { label: 'Declined', value: 'Rejected' }
  ];

  constructor(
    private productRequestQueueService: ProductRequestQueueService,
    private authService: AuthService,
    private router: Router,
    private artistService: ArtistsService,
    private ngxSpinnerService: NgxSpinnerService,
  ) { }

  public ngOnInit(): void {
    this.authConfig = this.authService.getAuthConfig();
    if (this.authConfig.IsGallery || this.authConfig.IsGalleryStaff) {
      this.galleryId = this.authService.getUserId();
      this.getGalleryProductRequests();
      this.getAllArtist();
    }
  }

  private getProductHistory() {    
    this.ngxSpinnerService.show();
    this.productRequestQueueService.getProductHistory().subscribe((artistProduct) => {
      this.history = artistProduct;
      console.log('RequestedProducts: ', this.history);
      this.ngxSpinnerService.hide();
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  private getGalleryProductRequests(artistId: string | null = null, filters: ArtistProductsSummaryRequest = {}) {
    this.isLoading = true;
    this.ngxSpinnerService.show();
    this.productRequestQueueService.getGalleryProductRequests(artistId, filters).subscribe((artistProduct) => {
      this.requestedProducts = artistProduct;
      this.totalRequestedProduct = artistProduct.length;
      console.log('RequestedProducts: ', this.requestedProducts);
      this.ngxSpinnerService.hide();
      this.isLoading = false;
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); this.isLoading = false; });
  }

  private getAllArtist() {
    this.artistService.getArtistsDropdownData().subscribe((artists) => {
      this.connectedArtists = artists;
    }, (error) => { console.error(error); });
  }

  public onArtistChanged($event: any) {
    this.filters = {};
    const selectedArtistValue = $event.value; // Get the selected artist's value
    const filteredArtist = this.connectedArtists.find(artist => artist.value === selectedArtistValue); // Find the artist object in the connectedArtists array

    if (filteredArtist) {
      this.selectedArtistId = filteredArtist; // Set the selectedArtistId to the found artist object
      this.getGalleryProductRequests(selectedArtistValue); // Fetch product requests for the selected artist
    } else {
      this.selectedArtistId = undefined; // Reset selectedArtistId if the artist is not found
      this.getGalleryProductRequests(); // Fetch product requests without filtering by artist
    }
  }
  public FilterByProductName() {
    const MIN_SEARCH_LENGTH = 3;
    const filterValue = this.searchText.trim().toLowerCase();
    if (filterValue.length >= MIN_SEARCH_LENGTH) {
      if (this.requestedProducts) {
        this.requestedProducts = this.requestedProducts.filter((product) =>
          product.ProductName && product.ProductName.toLowerCase().includes(filterValue)
        );
      }
    } else if (filterValue.length === 0) {
      this.getGalleryProductRequests();
    }

  }

  
  

  public onStatusFilterChange($event: any) {
    this.filters.RequestStatus = $event.value;    
    this.getGalleryProductRequests(null, this.filters);
  }

  public clearAllFilters($event: any) {
    this.selectedArtistId = undefined;
    this.searchText = '';
    this.artistId = null;
    this.filters = {};

    this.getGalleryProductRequests();
  }

  public showHistoryDialog(){
    this.productRequestHistoryVisible = true;
    this.getProductHistory();
  }

  public goToProductDetails(product: ProductRequest) {
    this.router.navigate(['/', product.ArtistId, 'artworks', product.ArtistProductId]);
  }
}
